// @flow

import LabeledInput from './labeledInput';
import ReduxFormLabeledInput from './labeledInput.reduxform';

export {
  ReduxFormLabeledInput,
};

export default LabeledInput;
